"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportProductPresentations = void 0;
const react_1 = require("react");
const errors_1 = require("@apollo/client/errors");
const react_2 = require("@apollo/client/react");
const export_products_mutation_1 = require("../client/export-products.mutation");
const table_columns_utils_1 = require("../../table-columns/table-columns.utils");
const attributes_1 = require("../../../constants/attributes");
const filter_formatters_1 = require("../../../preview-products-widget/preview-products-widget-content/hooks/table-data-source-formatters/filter.formatters");
const sort_formatter_1 = require("../../../preview-products-widget/preview-products-widget-content/hooks/table-data-source-formatters/sort.formatter");
const use_notification_hook_1 = require("../../../../hooks/use-notification.hook");
const localization_1 = require("../../../../localization");
const FALLBACK_COLUMNS = [
    attributes_1.CustomProductAttributes.Name,
    attributes_1.CustomProductAttributes.ExternalId,
    attributes_1.CustomProductAttributes.CreatedAt,
];
const useExportProductPresentations = ({ catalogId, productTreeId, productTreeNodeIds, tableFilter, tableSearch, tableSort, dynamicColumns, reviewStatus, selectedAttributeNode, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addError } = (0, use_notification_hook_1.useNotification)();
    const [exportMutation, { loading }] = (0, react_2.useMutation)(export_products_mutation_1.EXPORT_PRODUCTS);
    const exportProducts = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const filter = (0, filter_formatters_1.convertReduxFilterModelToGraphQL)({
                tableFilter,
                selectedAttributeNode,
                search: tableSearch || undefined,
                reviewStatus,
            });
            const sortItem = tableSort ? (0, sort_formatter_1.convertReduxSortModelToGraphQL)(tableSort, reviewStatus) : undefined;
            const sort = sortItem ? [sortItem] : undefined;
            const columns = dynamicColumns.columnsOrder.length > 0
                ? dynamicColumns.columnsOrder.map(table_columns_utils_1.toApiColumn)
                : FALLBACK_COLUMNS;
            const { data } = yield exportMutation({
                variables: {
                    input: {
                        catalog: catalogId,
                        productTreeId,
                        productTreeNodeIds,
                        clientMutationId: '',
                        columns,
                        filter,
                        sort,
                    },
                },
            });
            const result = data === null || data === void 0 ? void 0 : data.exportProductPresentationsCsv;
            if (result === null || result === void 0 ? void 0 : result.downloadUrl) {
                window.open(result.downloadUrl, '_blank');
            }
        }
        catch (error) {
            // Check for EXPORT_ROW_LIMIT_EXCEEDED error and show the specific message
            if (errors_1.CombinedGraphQLErrors.is(error)) {
                const exportError = error.errors.find((err) => { var _a; return ((_a = err.extensions) === null || _a === void 0 ? void 0 : _a.code) === 'EXPORT_ROW_LIMIT_EXCEEDED'; });
                if (exportError) {
                    addError(exportError.message);
                    return;
                }
            }
            addError(t({ key: 'EXPORT_CSV_ERROR' }));
        }
    }), [
        exportMutation,
        catalogId,
        productTreeId,
        productTreeNodeIds,
        tableFilter,
        tableSearch,
        tableSort,
        dynamicColumns,
        reviewStatus,
        selectedAttributeNode,
        t,
        addError,
    ]);
    return {
        exportProducts,
        loading,
    };
};
exports.useExportProductPresentations = useExportProductPresentations;
